import { httpCreate } from './http';

const http = httpCreate('/srv/user-config');

export const userConfig = {
	getUserConfig() {
		return http.get('');
	},
	setTemplate(type) {
		return http.post(`/template-default/${type}`);
	},
};
